import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article6 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = ['百万金币', '特享好礼', '发财小鸡', '庆典蛋糕', '珍馐雅味'];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-root-article">
        <div className={cx('xfe-layer-3', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-1', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-4" />
          <Link className="xfe-layer-5" data-id={'百万金币'} onClick={() => scrollToAnchor('百万金币')} />
          <Link className="xfe-layer-6" data-id={'特享好礼'} onClick={() => scrollToAnchor('特享好礼')} />
          <Link className="xfe-layer-7" data-id={'发财小鸡'} onClick={() => scrollToAnchor('发财小鸡')} />
          <Link className="xfe-layer-8" data-id={'庆典蛋糕'} onClick={() => scrollToAnchor('庆典蛋糕')} />
          <Link className="xfe-layer-9" data-id={'珍馐雅味'} onClick={() => scrollToAnchor('珍馐雅味')} />
        </div>

        <div className={cx('xfe-group-2', { visible: showSidebar })} data-name="侧栏导航">
          <div className="xfe-layer-10" />
          <div className="xfe-group-3" data-name="组 35">
            <Link className={cx('xfe-group-4', { active: activeAnchor === '百万金币' })} data-name="百万金币" onClick={() => scrollToAnchor('百万金币')}>
              <div className="xfe-layer-11" />
              <div className="xfe-layer-12" />
            </Link>

            <Link className={cx('xfe-group-5', { active: activeAnchor === '特享好礼' })} data-name="特享好礼" onClick={() => scrollToAnchor('特享好礼')}>
              <div className="xfe-layer-13" />
              <div className="xfe-layer-14" />
            </Link>

            <Link className={cx('xfe-group-6', { active: activeAnchor === '发财小鸡' })} data-name="发财小鸡" onClick={() => scrollToAnchor('发财小鸡')}>
              <div className="xfe-layer-15" />
              <div className="xfe-layer-16" />
            </Link>

            <Link className={cx('xfe-group-7', { active: activeAnchor === '庆典蛋糕' })} data-name="庆典蛋糕" onClick={() => scrollToAnchor('庆典蛋糕')}>
              <div className="xfe-layer-17" />
              <div className="xfe-layer-18" />
            </Link>

            <Link className={cx('xfe-group-8', { active: activeAnchor === '珍馐雅味' })} data-name="珍馐雅味" onClick={() => scrollToAnchor('珍馐雅味')}>
              <div className="xfe-layer-19" />
              <div className="xfe-layer-20" />
            </Link>

            <Link className="xfe-group-9" data-name="返回顶部" onClick={scrollToTop}>
              <div className="xfe-layer-21" />
              <div className="xfe-layer-22" />
            </Link>
          </div>
        </div>
        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article6, ArticleStore);
